import React, { useState, useEffect } from "react";
import { db } from "../../../config/firebaseConfig";
import { ref, get } from "firebase/database";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "../../../@/components/ui/accordion";
import { Skeleton } from "../../../@/components/ui/skeleton";

interface FAQ {
  question: string;
  answer: string;
}

interface FAQCategory {
  title: string;
  faqs: FAQ[];
}

const CustomerFAQs: React.FC = () => {
  const [faqData, setFaqData] = useState<FAQCategory>({ title: "", faqs: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFAQsData = async () => {
      try {
        const faqsRef = ref(db, "LayoutSettingData/FAQs/customers");
        const snapshot = await get(faqsRef);

        if (snapshot.exists()) {
          setFaqData(snapshot.val());
        } else {
          // If no data in Firebase, use the default from JSON file
          const defaultFaqs = await import("../../../assets/faqs.json");
          setFaqData(defaultFaqs.default.customers);
        }
      } catch (error) {
        console.error("Error fetching FAQs data:", error);
        // Fallback to static data
        const defaultFaqs = await import("../../../assets/faqs.json");
        setFaqData(defaultFaqs.default.customers);
      } finally {
        setLoading(false);
      }
    };

    fetchFAQsData();
  }, []);

  if (loading) {
    return (
      <div className="md:ml-[10%] flex font-helvetica flex-col text-black">
        <Skeleton className="h-[3.75vh] w-[200px] mb-[1.6vh]" />
        <div className="text-pretty mt-[1vh] space-y-[3%] leading-tight tracking-[-1%] w-full">
          {[...Array(5)].map((_, index) => (
            <div key={index} className="space-y-2">
              <Skeleton className="h-[40px] w-full" />
              <Skeleton className="h-[20px] w-[80%]" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="md:ml-[10%] flex font-helvetica flex-col text-black">
      <p className="font-helveticaBold space-y-[1.6vh] text-[3.75vh]">
        {faqData.title}
      </p>
      <div className="text-pretty mt-[1vh] space-y-[3%] leading-tight tracking-[-1%] w-full">
        <Accordion type="single" collapsible className="mt-2 w-full">
          {faqData.faqs.map((item, index) => (
            <AccordionItem key={index} value={`item-${index + 1}`}>
              <AccordionTrigger className="text-start w-full">
                {item.question}
              </AccordionTrigger>
              <AccordionContent>{item.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default CustomerFAQs;
